import { Grid } from '@mui/material';

import { HexColor } from '@nx-smartmonkey/shared/domain';
import { RightPanelHeader } from '../../../../components/right-panel-info/RightPanel.styled';
import { Vehicle as VehicleDomain } from '../../../../domain/vehicle/Vehicle';
import { useUpdateVehicle } from '../../../../hooks/vehicle/useUpdateVehicle';
import { VehicleAvatar } from '../../../shared/VehicleAvatar';

type VehicleHeaderProps = {
  vehicle: VehicleDomain;
  onClose: (...args: any[]) => any;
  options?: React.ReactElement | any;
};

export const VehicleHeader = ({ vehicle, onClose, options }: VehicleHeaderProps) => {
  const { run: updateVehicle } = useUpdateVehicle();

  const handleUpdate = (label: string, val: any) => {
    updateVehicle({ vehicle, changes: { [label]: val } });
  };

  if (vehicle) {
    return (
      <RightPanelHeader onClose={onClose}>
        <Grid container wrap="nowrap">
          <Grid item container justifyContent="flex-start" style={{ width: `100%` }} wrap="nowrap" alignItems="center">
            <VehicleAvatar
              vehicleId={vehicle.id}
              vehicleColor={vehicle.color?.value}
              withColorPicker
              onUpdate={(color: HexColor) => {
                handleUpdate(`color`, color);
              }}
            />
          </Grid>

          <Grid container direction="row" style={{ width: `auto` }} wrap="nowrap" alignItems="center">
            {options}
          </Grid>
        </Grid>
      </RightPanelHeader>
    );
  }
  return null;
};
